import { Box, Typography, useTheme } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation,Trans } from 'react-i18next'

import { facilityManagementItem } from './items'

const FacilityManagementSection = () => {
  const theme = useTheme()
  const {t}=useTranslation()
  const cards = facilityManagementItem()
  return (
    <Box
      sx={{
        margin: '0 auto',
        maxWidth: '100rem',
      }}
      mb={{ xs: 5, md: 8.75 }}
    >
      <Box pl={{ xs: 4, sm: 0 }} pr={{ xs: 4, sm: 0 }}>
        <Typography
          variant='h2'
          sx={{ mb: 1, color: 'publicPages.light' }}
          fontSize={{ xs: '1.75rem', md: '2.5rem' }}
          lineHeight={{ xs: '2.25rem', md: '3.375rem' }}
          fontWeight={600}
        >
          <Trans
            i18nKey='featuresPage.facilityManagement'
            components={{
              highlight: <span style={{ color: theme.palette.publicPages.contrastText }} />,
            }}
          />
        </Typography>
        <Typography
          variant='h5'
          sx={{ color: 'publicPages.colorTwo' }}
          lineHeight={'1.563rem'}
          fontWeight={400}
          fontSize={{ xs: '.8rem', md: '1rem' }}
        >
          {t('featuresPage.efficientlyManageText')}
        </Typography>
      </Box>
      <Grid
        container
        spacing={{ xs: 3, lg: 2, xl: 2 }}
        mt={{ xs: 2, md: 5 }}
        justifyContent='center'
        display={{ lg: 'inline-flex' }}
      >
        {cards.map((item) => (
          <Grid xs={12} md={6} lg={4} xl={4} key={item.id} display='flex' justifyContent='center'>
            <Box
              textAlign={'left'}
              sx={{
                backgroundImage: `url(${item.backgroundImage})`,
                width: { xs: '24rem', sm: '22rem', md: '24rem' },
                height: { xs: '20.3rem', sm: '19rem', md: '20.3rem' },
                borderRadius: '0.875rem',
                padding: 4,
                [theme.breakpoints.down(400)]: { width: '15.625rem', padding: 2 },
              }}
            >
              <Box component='img' src={item.icon} />
              <Typography
                variant='h6'
                sx={{
                  fontWeight: 600,
                  color: 'publicPages.colorOne',
                  lineHeight: 1.5,
                  mt: { xs: '3rem', sm: '2rem', md: '3rem' },
                  [theme.breakpoints.down(400)]: { mt: '1.5rem' },
                }}
              >
                {t(`featuresPage.${item.title}`)}
              </Typography>
              <Typography
                variant='h4'
                sx={{
                  fontSize: '1rem',
                  fontWeight: 300,
                  lineHeight: 1.88,
                  mt: '1.1rem',
                  maxWidth: '19.125rem',
                }}
              >
                {t(`featuresPage.${item.description}`)}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default FacilityManagementSection
